import { render, staticRenderFns } from "./_base-requester-picker.vue?vue&type=template&id=1f4f813b&"
import script from "./_base-requester-picker.vue?vue&type=script&lang=js&"
export * from "./_base-requester-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-requester-picker.vue?vue&type=style&index=0&id=1f4f813b&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports